import React from 'react'
import ReactDOM from 'react-dom/client'
import 'react-day-picker/style.css'
import './index.css'
import './i18n'
import App from './App'
import { useAuth } from './store/authStore'
import { isNativePlatform } from './lib/platform'

// Validate any stored member token on startup.
void useAuth.getState().hydrate()

// Register the PWA service worker on the web build (not inside Capacitor, not in dev).
if (import.meta.env.PROD && !isNativePlatform() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
